
// SVG Icon: measure
export default { id: "terriajs-measure" };
export const id = "terriajs-measure";
export const name = "measure";
